export default "__VITE_ASSET__CY6YIk_8__"